module.exports = __webpack_public_path__ + "static/img/case-2hefushe.e83af818.jpg";